import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class ReportTask {

  @JsonProperty()
  id: string;
  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  state: ReportTask.STATE;
  @JsonProperty()
  message: string;
  @JsonProperty()
  ccOperator: string;
  @JsonProperty()
  tempFilPath: string;
  @JsonProperty()
  reportProfileJson: string;
  @JsonProperty()
  origin: string;

}

export module ReportTask {
  export enum STATE {
    IN_PROGRESS = "IN_PROGRESS",
    TREATED = "TREATED",
    ERROR = "ERROR",
  }
  export enum Origin {
    WEB_REPORT = "WEB_REPORT",
    WEB_RECAP = "WEB_RECAP",
    WEB_REPORT_FORM = "WEB_REPORT_FORM",
    WEB_RECAP_FORM = "WEB_RECAP_FORM",
    WEB_RESIDUAL_ADJUSTMENT = "WEB_RESIDUAL_ADJUSTMENT",
    SYSTEM = "SYSTEM",
    SYSTEM_REPORT = "SYSTEM_REPORT",
    SYSTEM_RECAP = "SYSTEM_RECAP",
    SYSTEM_BILLING = "SYSTEM_BILLING",
    BILLING = "BILLING"
  }
}

